import './svg-sprite';
// Библиотеки (styles)
import 'normalize.css/normalize.css';
import 'swiper/css/bundle';
// Основные стили (styles)
import '../styles/main.scss';
// Mодули (scripts)
import infoSlidersInit from '../modules/info-slider/info-slider';
import tabsBlockInit from '../modules/tabs-block/tabs-block';
document.addEventListener('DOMContentLoaded', () => {
    infoSlidersInit();
    tabsBlockInit();
});
